{
  "title": "Summon Beast",
  "source": "Tasha's Cauldron of Everything",
  "levelAndSchool": "2nd-level conjuration",
  "level": 2,
  "castingTime": "1 action",
  "range": "90 feet",
  "components": "V, S, M (a feather, tuft of fur, and fish tail inside a gilded acorn worth at least 200 gp)",
  "duration": "Concentration, up to 1 hour",
  "description": [
    "You call forth a bestial spirit. It manifests in an unoccupied space that you can see within range. This corporeal form uses the Bestial Spirit stat block. When you cast the spell, choose an environment: Air, Land, or Water. The creature resembles an animal of your choice that is native to the chosen environment, which determines certain traits in its stat block. The creature disappears when it drops to 0 hit points or when the spell ends.",
    "The creature is an ally to you and your companions. In combat, the creature shares your initiative count, but it takes its turn immediately after yours. It obeys your verbal commands (no action required by you). If you don’t issue any, it takes the Dodge action and uses its move to avoid danger.",
    "At Higher Levels. When you cast this spell using a spell slot of 3rd level or higher, use the higher level where the spell’s level appears in the stat block.",
    "Bestial Spirit",
    "Small beast",
    "Armor Class: 11 + the level of the spell (natural armor)",
    "Hit Points: 20 (Air only) or 30 (Land and Water only) + 5 for each spell level above 2nd",
    "Speed: 30 ft., climb 30 ft. (Land only), fly 60 ft. (Air only), swim 30 ft. (Water only)",
    "STR",
    "DEX",
    "CON",
    "INT",
    "WIS",
    "CHA",
    "18 (+4)",
    "11 (+0)",
    "16 (+3)",
    "4 (−3)",
    "14 (+2)",
    "5 (−3)",
    "Senses: darkvision 60 ft., passive Perception 12",
    "Languages: understands the languages you speak",
    "Challenge: —",
    "Proficiency Bonus: equals your bonus",
    "Flyby (Air Only). The beast doesn’t provoke opportunity attacks when it flies out of an enemy’s reach.",
    "Pack Tactics (Land and Water Only). The beast has advantage on an attack roll against a creature if at least one of the beast’s allies is within 5 feet of the creature and the ally isn’t incapacitated.",
    "Water Breathing (Water Only). The beast can breathe only underwater.",
    "Actions",
    "Multiattack. The beast makes a number of attacks equal to half this spell’s level (rounded down).",
    "Maul. Melee Weapon Attack: your spell attack modifier to hit, reach 5 ft., one target. Hit: 1d8 + 4 + the spell’s level piercing damage."
  ],
  "spellLists": ["druid", "ranger"]
}
